import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';

const NavigationBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <Navbar 
      expand="lg" 
      fixed="top" 
      className="shadow-sm"
      style={{
        backgroundColor: '#1e3a8a', // Deep blue background
        borderBottom: '3px solid #3b82f6' // Blue border
      }}
    >
      <Container>
        <Navbar.Brand 
          as={Link} 
          to="/" 
          className="fw-bold"
          style={{
            color: '#ffffff',
            fontSize: '1.25rem',
            textDecoration: 'none'
          }}
        >
          ATS - Applicant Tracking System
        </Navbar.Brand>
        
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav"
          style={{
            borderColor: '#ffffff',
            color: '#ffffff'
          }}
        />
        
        <Navbar.Collapse id="basic-navbar-nav">
          {/* Use ms-auto to push nav items to the right */}
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link} 
              to="/dashboard" 
              className={`mx-2 fw-semibold ${isActive('/dashboard') || isActive('/') ? 'active' : ''}`}
              style={{
                color: isActive('/dashboard') || isActive('/') ? '#fbbf24' : '#e5e7eb',
                backgroundColor: isActive('/dashboard') || isActive('/') ? 'rgba(251, 191, 36, 0.1)' : 'transparent',
                borderRadius: '6px',
                padding: '8px 16px',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#ffffff';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#e5e7eb';
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              Dashboard
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/applicants" 
              className={`mx-2 fw-semibold ${isActive('/applicants') ? 'active' : ''}`}
              style={{
                color: isActive('/applicants') ? '#fbbf24' : '#e5e7eb',
                backgroundColor: isActive('/applicants') ? 'rgba(251, 191, 36, 0.1)' : 'transparent',
                borderRadius: '6px',
                padding: '8px 16px',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#ffffff';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#e5e7eb';
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              Applicants
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/bulk-upload" 
              className={`mx-2 fw-semibold ${isActive('/bulk-upload') ? 'active' : ''}`}
              style={{
                color: isActive('/bulk-upload') ? '#fbbf24' : '#e5e7eb',
                backgroundColor: isActive('/bulk-upload') ? 'rgba(251, 191, 36, 0.1)' : 'transparent',
                borderRadius: '6px',
                padding: '8px 16px',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#ffffff';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#e5e7eb';
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              Bulk Upload
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/reports" 
              className={`mx-2 fw-semibold ${isActive('/reports') ? 'active' : ''}`}
              style={{
                color: isActive('/reports') ? '#fbbf24' : '#e5e7eb',
                backgroundColor: isActive('/reports') ? 'rgba(251, 191, 36, 0.1)' : 'transparent',
                borderRadius: '6px',
                padding: '8px 16px',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#ffffff';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#e5e7eb';
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              Reports
            </Nav.Link>
            
            <Nav.Link 
              as={Link} 
              to="/notifications" 
              className={`mx-2 fw-semibold ${isActive('/notifications') ? 'active' : ''}`}
              style={{
                color: isActive('/notifications') ? '#fbbf24' : '#e5e7eb',
                backgroundColor: isActive('/notifications') ? 'rgba(251, 191, 36, 0.1)' : 'transparent',
                borderRadius: '6px',
                padding: '8px 16px',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#ffffff';
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (!e.target.classList.contains('active')) {
                  e.target.style.color = '#e5e7eb';
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              Notifications
            </Nav.Link>
            <Nav.Link 
              onClick={() => {
                localStorage.removeItem('token');
                navigate('/login', { replace: true });
              }}
              className="mx-2 fw-semibold"
              style={{
                color: '#e5e7eb',
                borderRadius: '6px',
                padding: '8px 16px',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#ffffff';
                e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#e5e7eb';
                e.target.style.backgroundColor = 'transparent';
              }}
            >
              Logout
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
